<div *ngIf="!asMenu">
	<button *ngFor="let button of visibleButtons(); key: 'label'" mat-button [color]="button.color || 'primary'" (click)="button.onClick($event)"
		[attr.aria-label]="button.ariaLabel || button.label" class="linq-button-text" [ngClass]="button.cssClass"
		[disabled]="button.disabled && button.disabled()">
		<mat-icon *ngIf="button.icon">{{ button.icon }}</mat-icon>
		{{ button.label }}
	</button>
</div>

<div *ngIf="asMenu">
	<button mat-button [matMenuTriggerFor]="menu" [color]="'primary'">
		{{ menuLabel }} <mat-icon>expand_more</mat-icon>
	</button>
	<mat-menu #menu="matMenu">
		<button *ngFor="let button of visibleButtons(); key: 'label'" mat-menu-item (click)="button.onClick($event)"
			[attr.aria-label]="button.ariaLabel || button.label" class="linq-button-text" [ngClass]="button.cssClass"
			[disabled]="button.disabled && button.disabled()">
			<mat-icon *ngIf="button.icon">{{ button.icon }}</mat-icon>
			{{ button.label }}
		</button>
	</mat-menu>
</div>
